import {Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {GoogleMap} from '@angular/google-maps';
import {Entity} from '../../../classes/entity';
import {Utils} from '../../../utils.class';

@Component({
    selector: 'app-text-overlay',
    template: '',
})
export class TextOverlayComponent implements OnInit, OnDestroy, OnChanges {
    @Input() entity: Entity;
    @Input() map: GoogleMap;
    @Input() text: string;
    @Input() zoom: number;

    // @ts-ignore
    private overlay: TextOverlay;

    ngOnInit() {
        if (this.entity && this.text) {
            Utils.googleMapsCore().then(() => this.drawOverlay());
        }
    }

    drawOverlay() {
        class TextOverlay extends google.maps.OverlayView {
            private bounds: google.maps.LatLngBounds;
            private div?: HTMLElement;

            constructor(private entity: Entity,
                        private map: GoogleMap,
                        private text: string,
                        private zoom: number) {
                super();
                this.setBounds();
                this.entity.updateBboxText = () => {
                    this.setBounds();
                };
            }

            setBounds() {
                this.bounds = new google.maps.LatLngBounds(...Utils.convertGeometry(this.entity.bbox));
            }



            override onAdd() {
                this.div = document.createElement('div');
                this.div.style.position = 'absolute';
                this.div.style.pointerEvents = 'none';
                this.div.style.zIndex = '200';
                this.applyContent();

                const panes = this.getPanes()!;
                panes.floatPane.appendChild(this.div);
            }

            private applyContent() {
                if (!this.div) {
                    return;
                }
                if (this.zoom >= 18) {
                    this.div.textContent = '';
                    this.div.innerHTML = this.text.replaceAll('\n', '<br>');;
                    this.div.style.maxWidth = '200px';
                    this.div.style.background = 'rgba(249,250,0.92)';
                    this.div.style.border = '1px solid #ccc';
                    this.div.style.borderRadius = '4px';
                    this.div.style.padding = '4px 7px';
                    this.div.style.fontSize = '12px';
                    this.div.style.lineHeight = '1.4';
                    this.div.style.boxShadow = '0 1px 4px rgba(0,0,0,0.2)';
                    this.div.style.whiteSpace = 'normal';
                    this.div.style.overflow = 'hidden';
                    this.div.style.display = '-webkit-box';
                    this.div.style.webkitLineClamp = '4';
                    this.div.style.webkitBoxOrient = 'vertical';
                    this.div.style.textOverflow = 'ellipsis';
                } else {
                    this.div.textContent = '';
                    this.div.innerHTML = '<i class="fa fa-comment" style="font-size:14px;color:#555;text-shadow:0 1px 3px rgba(255,255,255,0.9)"></i>';
                    this.div.style.whiteSpace = 'normal';
                    this.div.style.maxWidth = 'none';
                    this.div.style.background = 'none';
                    this.div.style.border = 'none';
                    this.div.style.borderRadius = '0';
                    this.div.style.padding = '0';
                    this.div.style.fontSize = '';
                    this.div.style.lineHeight = '';
                    this.div.style.boxShadow = 'none';
                }
            }

            override draw() {
                const overlayProjection = this.getProjection();
                if (!overlayProjection || !this.div) {
                    return;
                }

                const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest())!;
                const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast())!;

                const right = Math.max(sw.x, ne.x);
                const top = Math.min(sw.y, ne.y);
                const bottom = Math.max(sw.y, ne.y);
                const centerY = (top + bottom) / 2;

                this.div.style.left = (right + 6) + 'px';
                this.div.style.top = centerY + 'px';
                this.div.style.transform = 'translateY(-50%)';
            }

            update(text: string, zoom: number) {
                this.text = text.replaceAll('\n', '<br>');
                this.zoom = zoom;
                this.applyContent();
                this.draw();
            }

            override onRemove() {
                if (this.div) {
                    this.div.parentNode?.removeChild(this.div);
                    delete this.div;
                }
            }
        }

        this.overlay = new TextOverlay(this.entity, this.map, this.text, this.zoom);
        this.overlay.setMap(this.map.googleMap);
    }

    ngOnChanges() {
        this.overlay?.update(this.text, this.zoom);
    }

    ngOnDestroy() {
        this.overlay?.setMap(null);
        this.overlay?.onRemove();
    }
}
